import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, Building2, X } from "lucide-react";
import { ENASUSPRO_URL } from "@/data/content";

// The requested "kutucuk": a distinctive floating box that switches to the parent brand enasuspro.com
export const EnasusproWidget = () => {
  const [dismissed, setDismissed] = useState(false);
  const [hover, setHover] = useState(false);

  if (dismissed) return null;

  return (
    <motion.div
      initial={{ y: 60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1.6, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-6 right-6 z-50"
      data-testid="enasuspro-widget"
    >
      <a
        href={ENASUSPRO_URL}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className="group relative flex items-center gap-3 rounded-full border border-white/10 bg-[#121212]/90 p-2 pr-5 shadow-2xl backdrop-blur-md transition-colors duration-300 hover:border-[#D4F870]"
        data-testid="enasuspro-widget-link"
      >
        <span className="grid h-11 w-11 place-items-center rounded-full bg-[#D4F870] text-[#0A0A0A]">
          <Building2 className="h-5 w-5" strokeWidth={2} />
        </span>
        <span className="flex flex-col leading-tight">
          <span className="text-[10px] uppercase tracking-[0.24em] text-[#9CA3AF]">
            Ana marka
          </span>
          <span className="font-display text-[15px] text-[#F3F4F6]">
            Enasuspro'ya geç
          </span>
        </span>
        <AnimatePresence>
          {hover && (
            <motion.span
              initial={{ width: 0, opacity: 0, marginLeft: 0 }}
              animate={{ width: "auto", opacity: 1, marginLeft: 4 }}
              exit={{ width: 0, opacity: 0, marginLeft: 0 }}
              className="grid h-8 w-8 place-items-center rounded-full bg-white/5 text-[#D4F870]"
            >
              <ArrowUpRight className="h-4 w-4" />
            </motion.span>
          )}
        </AnimatePresence>
      </a>

      <button
        onClick={() => setDismissed(true)}
        aria-label="Kapat"
        data-testid="enasuspro-widget-dismiss"
        className="absolute -right-1 -top-1 grid h-5 w-5 place-items-center rounded-full border border-white/10 bg-[#0A0A0A] text-[#9CA3AF] transition-colors hover:text-[#F3F4F6]"
      >
        <X className="h-3 w-3" />
      </button>
    </motion.div>
  );
};
